<template>
  <section class="video">
    <div v-if="video" class="video-y">
      <iframe :src="`https://www.youtube.com/embed/${videoYoutube(video)}`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  </section>
</template>

<script>
  import StringMixin from "../mixins/StringMixin";

  export default {
    mixins: [StringMixin],
    props: {
      video: String,
      size:  { default: 65 },
    },
  }
</script>

<style lang="scss" scoped>
  .video {
    width: 100%;
    iframe {
      width: 100%;
      height: 700px;
      @media (max-width: $media_md) {
        height: 600px;
      }
      @media (max-width: $media_sm) {
        height: 500px;
      }
      @media (max-width: $media_xs) {
        height: 300px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// components/shared/content/ContentVideo.vue